module.exports = __webpack_public_path__ + "assets/fe63037f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/movie1.jpg
// module id = 95
// module chunks = 0